<template>
  <svg
    class="w-4 h-4"
    :class="[orientationClass, `text-${color}`]"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  color: {
    type: String,
    required: false,
    default: 'gray-800'
  },
  orientation: {
    type: String,
    required: false,
    default: 'right-up'
  }
})

const ORIENTATION_CLASSES = {
  'right-up': '-rotate-45',
  'right-bottom': 'rotate-45'
}

const orientationClass = computed(() => ORIENTATION_CLASSES[props.orientation])

</script>
